import { supabase } from '../supabaseClient';

async function getAllInventory(projectId) {
    let query = supabase.from('Inventory').select('*,wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventorySubTypeId(*)', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getLaunchInventory(launchId) {
    let query = supabase.from('LaunchInventoryRelations').select('*,wingId(*),unitId(*,wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventoryMergeId(*))', { count: 'exact' }).eq('launchId', launchId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getProjectInventory(projectId) {
    let query = supabase.from('ProjectInventoryRelations').select('*, projectId(*),wingId(*),unitId(*,wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventoryMergeId(*) ,leadId(* , personId(*)))', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getUnitsForSdrPercentage(projectId) {
    let query = supabase.from('Inventory').select('* ,wingId(*),inventoryTypeId(*),InventoryStatus!inner(*) , AllotmentPayment!left(* , CRM!left(*))', { count: 'exact' })
    .eq('projectId', projectId)
    .neq('InventoryStatus.status' , 'Sold')
    .not('BSP' , 'is' , null)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getProjectForPaymentPlan(projectId) {
    let query = supabase.from('Projects').select('*, Wings!left(*)', { count: 'exact' }).eq('projectId', projectId).maybeSingle()
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}


async function getProjectInventoryWithLeadData(projectId) {
    let query = supabase.from('ProjectInventoryRelations').select('*,wingId(*),unitId(*,wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventoryMergeId(*) ,leadId(* , personId(*) , userId(*)))', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

// JD projects: ProjectInventoryRelations of the VJ parent (salesParentProjectId) is the main source.
// Rows are narrowed to units whose Inventory.jdBuId matches the JD project's buId, and each unit's
// jdWingId (holds Wings.wingId) is matched to the JD project's Wings. VJ projects are returned unchanged.
async function getProjectInventoryByType(projectId) {
    const { data: project, error } = await supabase.from('Projects').select('*').eq('projectId', projectId).maybeSingle();
    if (error) throw error;
    if (project?.isVJ !== false) return getProjectInventory(projectId);

    const rows = await getProjectInventory(project.salesParentProjectId);
    const jdRows = rows.filter((r) => r.unitId && String(r.unitId.jdBuId) === String(project.buId));

    const jdWingIds = [...new Set(jdRows.map((r) => r.unitId.jdWingId).filter(Boolean))];
    let wings = [];
    if (jdWingIds.length) {
        const { data, error: wErr } = await supabase.from('Wings').select('*').eq('projectId', projectId).in('wingId', jdWingIds);
        if (wErr) throw wErr;
        wings = data;
    }

    return jdRows.map((r) => {
        const wing = wings.find((w) => w.wingId === r.unitId.jdWingId) || null;
        return { ...r, projectId: project, wingId: wing, unitId: { ...r.unitId, wingId: wing } };
    });
}

async function getJdInventoryByProject(buId) {
    const { data, error } = await supabase
        .from('Inventory')
        .select('*, inventoryTypeId(*), inventoryStatusId(*)')
        .eq('jdBuId', buId);
    if (data) return data;
    else throw error;
}


async function getPreselectInventory(eventTokenId, launchId) {
    let query = supabase.from('PreselectInventoryRelations').select('*,wingId(*),unitId(*,wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventoryMergeId(*))', { count: 'exact' }).eq('eventTokenId', eventTokenId).eq('launchId', launchId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getLaunchInventoryForPreselect(launchId) {
    let query = supabase.from('LaunchInventoryRelations').select('*,wingId(*),unitId(*,inventoryTypeId(*),inventoryMergeId(*))', { count: 'exact' }).eq('launchId', launchId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function insertIntoInventoryRelations(obj, eventId) {
    obj.created_at = Date.now()
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "selected", eventId: eventId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('LaunchInventoryRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function insertIntoProjectInventoryRelations(obj) {
    obj.created_at = Date.now()
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "selected", projectId: obj.projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('ProjectInventoryRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function insertIntoPreselectInventoryRelations(obj) {
    obj.created_at = Date.now()
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "selected", eventTokenId: obj.eventTokenId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('PreselectInventoryRelations').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteInventoryRelations(obj, launchId, eventId) {
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "deselected", eventId: eventId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('LaunchInventoryRelations').delete().eq('launchId', launchId).eq('unitId', obj.unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteInventoryRelationsOfLaunch(launchId) {
    let query = supabase.from('LaunchInventoryRelations').delete().eq('launchId', launchId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteInventoryRelationsOfProject(obj, projectId) {
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "deselected", projectId: projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('ProjectInventoryRelations').delete().eq('projectId', projectId).eq('unitId', obj.unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function deleteInventoryRelationsOfPreselect(obj, eventTokenId) {
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unitId, status: "deselected", eventTokenId: eventTokenId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('PreselectInventoryRelations').delete().eq('eventTokenId', eventTokenId).eq('unitId', obj.unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function updateInventoryRelations(obj, launchId, unitId) {
    obj.last_updated_at = new Date().getTime()
    let query = supabase.from('LaunchInventoryRelations').update(obj).eq('launchId', launchId).eq('unitId', unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function updateProjectInventoryRelations(obj, projectId, unitId) {
    obj.last_updated_at = new Date().getTime()
    let query = supabase.from('ProjectInventoryRelations').update(obj).eq('projectId', projectId).eq('unitId', unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function updateInventory(obj, unitId) {
    obj.last_updated_at = new Date().getTime()
    let query = supabase.from('Inventory').update(obj).eq('unitId', unitId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getInventoryStatus() {
    let query = supabase.from('InventoryStatus').select('*', { count: 'exact' })
    const { data, error } = await query;
    if (data) return data;
    else throw error;
}

async function getInventoryMerge(projectId) {
    let query = supabase.from('InventoryMerge').select('*', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function deleteInventoryMerge(obj) {
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unit1Id, status: "demerged", projectId: obj.projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    const { data2, error2 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unit2Id, status: "demerged", projectId: obj.projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('InventoryMerge').delete().eq('inventoryMergeId', obj.inventoryMergeId)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function insertIntoInventoryMerge(obj) {
    obj.created_at = Date.now()
    const { data1, error1 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unit1Id, status: "merged", projectId: obj.projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    const { data2, error2 } = await supabase.from('InventoryLogs').insert({ unitId: obj.unit2Id, status: "merged", projectId: obj.projectId, userId: JSON.parse(localStorage.getItem('user')).userId })
    let query = supabase.from('InventoryMerge').insert(obj)
    const { data, error } = await query;
    if (data) return { data };
    else throw error;
}

async function getInventoryByBuid(buid) {
    const { data, error } = await supabase.from('Inventory').select('*,projectId(*),wingId(*)').eq('projectId', buid)
    if (data) return { data }
    else throw error
}

async function getWingByName(projectId, wingName) {
    const { data, error } = await supabase.from('Wings').select('*').eq('projectId', projectId).eq('wingName', wingName)
    if (data) return { data }
    else throw error
}


async function getTemplateMappingByProjectId(projectId) {
    const { data, error } = await supabase.from('AgreementTemplateMappings').select('*').eq('projectId', projectId)
    if (data) return { data }
    else throw error
}

async function insertDataForTemplateMapping(obj) {
    const { data, error } = await supabase.from('AgreementTemplateMappings').insert(obj)
    if (data) return { data }
    else throw error
}

async function updateDataForTemplateMapping(obj,paymentPlanId,projectId) {
    const { data, error } = await supabase.from('AgreementTemplateMappings').update(obj).eq('projectId', projectId).eq('paymentPlanId',paymentPlanId)
    if (data) return { data }
    else throw error
}

async function getAllInventoryWithProjectDetails(projectId) {
    let query = supabase.from('Inventory').select('*,projectId(*),wingId(*),inventoryTypeId(*),inventoryStatusId(*),inventorySubTypeId(*)', { count: 'exact' }).eq('projectId', projectId)
    const { data, error, count } = await query;
    if (data) return data;
    else throw error;
}

async function getInventoryTypeId(unitId) {
    const { data, error } = await supabase
      .from('Inventory')
      .select("*, inventoryTypeId(*)")
      .eq('unitId', unitId)
    if (data) return data;
    else throw error;
  }

async function getInventoryLogsByUnit(unitId) {
  const { data, error, count } = await supabase
    .from('InventoryLogs')
    .select(`
      *,
      user:userId (
        id,
        name
      )
    `, { count: 'exact' })
    .eq('unitId', unitId) // Filter by unitId
    .order('created_at', { ascending: false }); // Optional: Order logs by creation date (most recent first)

  if (error) throw error;
  console.log('inventory logs data', data)
  return data;
}


export {
    getAllInventory, getWingByName, getInventoryByBuid, insertIntoPreselectInventoryRelations, insertIntoProjectInventoryRelations, deleteInventoryRelationsOfPreselect, getPreselectInventory, deleteInventoryRelationsOfProject, getLaunchInventory, updateInventory, deleteInventoryRelationsOfLaunch, deleteInventoryMerge, updateInventoryRelations, insertIntoInventoryMerge, insertIntoInventoryRelations, getProjectInventory, updateProjectInventoryRelations, deleteInventoryRelations, getInventoryStatus, getInventoryMerge,
    getProjectForPaymentPlan, getLaunchInventoryForPreselect,
  getProjectInventoryWithLeadData,
  getUnitsForSdrPercentage,getTemplateMappingByProjectId,
  updateDataForTemplateMapping,insertDataForTemplateMapping,getAllInventoryWithProjectDetails,getInventoryTypeId,
  getInventoryLogsByUnit,
  getJdInventoryByProject,
  getProjectInventoryByType
}